import React, { useEffect, useState } from 'react';
import axiosInstance from '../api/axiosConfig';
import renaultLogo from '../assets/renault.png';
import nissanLogo from '../assets/nissan.svg';
import fotonLogo from '../assets/foton.svg';
import baicLogo from '../assets/baic.svg';

const colors = {
  background: '#0f1117',
  cardBg: '#1a1c23',
  headerBg: '#12141b',
  primary: '#3b82f6',
  secondary: '#6366f1',
  accent: '#22c55e',
  text: '#e3e4e8',
  textMuted: '#9ca3af',
  border: '#2d3748',
  success: '#10b981',
  warning: '#f59e0b',
  error: '#ef4444',
};

const AdminDashboard = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [brandsCityData, setBrandsCityData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [expandedBrand, setExpandedBrand] = useState('all');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const dashRes = await axiosInstance.get('/dashboard/client');
        setDashboardData(dashRes.data);

        const cityRes = await axiosInstance.get('/dashboard/brands-city-distribution');
        setBrandsCityData(cityRes.data);
      } catch (err) {
        console.error('Error al obtener datos del dashboard:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading || !dashboardData) {
    return (
      <div style={{ color: colors.text, fontSize: '16px', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px', background: colors.cardBg, borderRadius: '12px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
        Cargando datos del dashboard...
      </div>
    );
  }

  const { totalVehicles, topBrands } = dashboardData;

  const getPercentageColor = (percentage) => {
    const pct = parseFloat(percentage);
    if (pct >= 30) return colors.success;
    if (pct >= 15) return colors.warning;
    return colors.textMuted;
  };

  const getBrandLogo = (brandName) => {
    const logos = {
      'RENAULT': renaultLogo,
      'NISSAN': nissanLogo,
      'FOTON': fotonLogo,
      'BAIC': baicLogo,
    };
    return logos[brandName] || null;
  };

  const handleBrandClick = (brandId) => {
    setExpandedBrand(expandedBrand === brandId ? null : brandId);
  };

  return (
    <div style={{ background: colors.background, color: colors.text, padding: '2rem', borderRadius: '16px', boxShadow: '0 8px 16px rgba(0,0,0,0.2)', fontFamily: "'Inter', 'Segoe UI', sans-serif" }}>
      <h2 style={{ marginTop: 0, color: colors.primary, fontSize: '28px', fontWeight: '600', marginBottom: '2rem' }}>Panel de Administración</h2>

      <div style={{ display: 'grid', gap: '1.5rem', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', marginBottom: '2rem' }}>
        <div style={{ background: colors.cardBg, borderRadius: '12px', padding: '1.5rem', border: '1px solid ' + colors.border, textAlign: 'center' }}>
          <div style={{ fontSize: '16px', color: colors.textMuted, marginBottom: '0.5rem' }}>Total de Vehículos</div>
          <div style={{ fontSize: '32px', fontWeight: 'bold', color: colors.primary }}>{totalVehicles}</div>
        </div>
      </div>

      <div style={{ background: colors.cardBg, border: '1px solid ' + colors.border, borderRadius: '12px', padding: '1.5rem', marginBottom: '2rem' }}>
        <h3 style={{ marginTop: 0, color: colors.primary, marginBottom: '1.5rem', fontSize: '20px', fontWeight: '600' }}>Marcas Disponibles</h3>
        {topBrands && topBrands.length > 0 ? (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '1rem' }}>
            {topBrands.map((b, index) => {
              const logo = getBrandLogo(b.brandName);
              return (
                <div key={b.brandName} style={{ background: colors.background, borderRadius: '12px', padding: '1rem', border: '1px solid ' + colors.border, textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                  {logo && (
                    <img 
                      src={logo} 
                      alt={b.brandName} 
                      style={{ height: '80px', marginBottom: '0.75rem', objectFit: 'contain' }}
                    />
                  )}
                  <div style={{ color: colors.textMuted, fontSize: '16px', marginBottom: '0.5rem', fontWeight: '500' }}>{b.brandName}</div>
                  <div style={{ fontWeight: '600', fontSize: '24px', color: [colors.primary, colors.secondary, colors.accent][index % 3] }}>{b.totalCount}</div>
                </div>
              );
            })}
          </div>
        ) : (
          <p style={{ color: colors.textMuted }}>No hay datos de marcas disponibles.</p>
        )}
      </div>

      <div style={{ marginTop: '2rem' }}>
        <h3 style={{ marginTop: 0, color: colors.primary, marginBottom: '1.5rem', fontSize: '20px', fontWeight: '600' }}>Distribución de Vehículos por Marca y Ciudad</h3>

        {brandsCityData && brandsCityData.length > 0 ? (
          <div style={{ display: 'grid', gap: '1rem', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))' }}>
            {brandsCityData.map((brand) => {
              const isExpanded = true;

              return (
                <div key={brand.brandId} style={{ background: colors.background, border: '1px solid ' + colors.border, borderRadius: '12px', overflow: 'hidden' }}>
                  <div onClick={() => handleBrandClick(brand.brandId)} style={{ background: colors.cardBg, padding: '1rem', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', userSelect: 'none' }}>
                    <div>
                      <h4 style={{ margin: '0 0 0.25rem 0', color: colors.secondary, fontSize: '16px', fontWeight: '600' }}>{brand.brandName}</h4>
                      <p style={{ margin: 0, color: colors.accent, fontSize: '14px', fontWeight: '600' }}>Total: {brand.totalCount}</p>
                    </div>
                    <div style={{ color: colors.primary, fontSize: '18px' }}>
                      {isExpanded ? '▲' : '▼'}
                    </div>
                  </div>

                  {isExpanded && (
                    <div style={{ padding: '1rem', borderTop: '1px solid ' + colors.border }}>
                      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                        <thead>
                          <tr style={{ background: colors.headerBg }}>
                            <th style={{ padding: '8px', textAlign: 'left', borderBottom: '1px solid ' + colors.border, color: colors.primary, fontWeight: '600' }}>Ciudad</th>
                            <th style={{ padding: '8px', textAlign: 'center', borderBottom: '1px solid ' + colors.border, color: colors.primary, fontWeight: '600' }}>Cant.</th>
                            <th style={{ padding: '8px', textAlign: 'center', borderBottom: '1px solid ' + colors.border, color: colors.primary, fontWeight: '600' }}>%</th>
                          </tr>
                        </thead>
                        <tbody>
                          {brand.cities.map((city, idx) => (
                            <tr key={idx} style={{ borderBottom: '1px solid ' + colors.border, background: idx % 2 === 0 ? colors.cardBg : 'transparent' }}>
                              <td style={{ padding: '8px', color: colors.text, fontWeight: city.city === 'Otros' ? '600' : '400' }}>{city.city}</td>
                              <td style={{ padding: '8px', textAlign: 'center', color: colors.accent, fontWeight: '600' }}>{city.count}</td>
                              <td style={{ padding: '8px', textAlign: 'center', color: getPercentageColor(city.percentage), fontWeight: '600' }}>{city.percentage}%</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        ) : (
          <div style={{ background: colors.cardBg, border: '1px solid ' + colors.border, borderRadius: '12px', padding: '2rem', textAlign: 'center', color: colors.textMuted }}>
            No hay datos de distribución por ciudad disponibles.
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminDashboard;
